"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Oauth1Interceptor = void 0;
const infinity_logger_1 = require("@carrier/infinity-logger");
const oauth1_utils_1 = require("../utils/oauth1-utils");
const oauth1_helper_1 = require("../core/oauth1.helper");
const request_utils_1 = require("../utils/request-utils");
const SIGNATURE_METHOD = "HMAC-SHA1";
const OAUTH_VERSION = "1.0";
class Oauth1Interceptor {
    constructor(consumerKey, consumerSecret, oauth1Helper = new oauth1_helper_1.Oauth1Helper()) {
        this.consumerKey = consumerKey;
        this.consumerSecret = consumerSecret;
        this.oauth1Helper = oauth1Helper;
    }
    buildUrl(request) {
        var _a, _b;
        let url = (_a = request.url) !== null && _a !== void 0 ? _a : "";
        let baseURL = (_b = request.baseURL) !== null && _b !== void 0 ? _b : "";
        if (baseURL) {
            if (url) {
                if (baseURL.endsWith("/")) {
                    baseURL = baseURL.substring(0, baseURL.length - 1);
                }
                if (url.startsWith("/")) {
                    url = url.substring(1, baseURL.length);
                }
                return `${baseURL}/${url}`;
            }
            else {
                return baseURL;
            }
        }
        if (!request.url) {
            throw new Error("url not defined");
        }
        return request.url;
    }
    intercept(request, token, tokenSecret) {
        var _a, _b;
        let contentType = request_utils_1.getContentType(request);
        let fullUrl = this.buildUrl(request);
        let timestamp = oauth1_utils_1.currentTimestamp();
        let nonce = this.oauth1Helper.generateNonce(timestamp, token);
        let httpMethod = (_b = (_a = request.method) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : "";
        if (!httpMethod) {
            throw new Error("http method empty");
        }
        let sigRequest = {
            httpMethod: httpMethod,
            url: fullUrl,
            consumerKey: this.consumerKey,
            consumerSecret: this.consumerSecret,
            token: token,
            tokenSecret: tokenSecret,
            signatureMethod: SIGNATURE_METHOD,
            nonce: nonce,
            timestamp: timestamp,
            version: OAUTH_VERSION,
            realm: fullUrl
        };
        // parses the body params
        let bodyParams = {};
        if (contentType === null || contentType === void 0 ? void 0 : contentType.startsWith("application/x-www-form-urlencoded")) {
            let params = request_utils_1.parseBodyForParameters(request.data);
            if (params) {
                bodyParams = params;
            }
        }
        sigRequest.parameters = Object.assign(Object.assign({}, bodyParams), request.params);
        logger.debugObject("intercept", sigRequest);
        let signature = this.oauth1Helper.generateSignature(sigRequest);
        let oauth1Header = {
            signature: signature,
            consumerKey: this.consumerKey,
            nonce: nonce,
            signatureMethod: SIGNATURE_METHOD,
            timestamp: timestamp,
            token: token,
            url: fullUrl,
            version: OAUTH_VERSION
        };
        logger.debugObject("intercept", oauth1Header);
        request.headers.Authorization = this.oauth1Helper.buildAuthorizationHeader(oauth1Header);
        logger.debug("intercept", request.headers.Authorization);
        return request;
    }
    ;
}
exports.Oauth1Interceptor = Oauth1Interceptor;
const logger = infinity_logger_1.createLogger(Oauth1Interceptor.name);
//# sourceMappingURL=axios.interceptor.js.map